@if (parsedHtml()) {
  <div [innerHTML]="$any(parsedHtml()) | safeHtml"></div>
}
